import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';

const LoveList: React.FC = () => {
    const { getArray } = useLanguage();
    const loveItems = getArray('things');
    const [activeItem, setActiveItem] = useState<number | null>(null);

    return (
        <div className="px-6 py-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                {loveItems.map((item, index) => (
                    <motion.div
                        key={item.id}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: (index % 10) * 0.05 }}
                        whileHover={{ y: -5, scale: 1.02 }}
                        onClick={() => setActiveItem(activeItem === item.id ? null : item.id)}
                        className={`cursor-pointer rounded-3xl p-6 transition-all border-2 flex flex-col items-center text-center relative overflow-hidden shadow-lg ${activeItem === item.id
                            ? 'bg-primary-red/10 border-primary-red'
                            : 'bg-white dark:bg-romantic-cardDark border-primary-red/5'
                            }`}
                    >
                        {/* Number badge */}
                        <div className="absolute top-4 right-4 w-8 h-8 rounded-full bg-primary-red text-white flex items-center justify-center text-xs font-bold">
                            {item.id}
                        </div>

                        <div className="text-4xl mb-4 transform group-hover:scale-110 transition-transform">
                            {item.emoji}
                        </div>

                        <p className={`font-poppins font-medium leading-relaxed ${activeItem === item.id ? 'text-primary-red' : 'text-gray-700 dark:text-gray-300'
                            }`}>
                            {item.text}
                        </p>

                        {/* Active indicator */}
                        <div className="mt-4">
                            <Heart
                                size={18}
                                className={activeItem === item.id ? 'text-primary-red fill-current' : 'text-primary-red/20'}
                            />
                        </div>
                    </motion.div>
                ))}
            </div>

            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                className="mt-16 bg-primary-red/5 dark:bg-primary-red/10 py-10 px-8 rounded-[3rem] text-center border border-primary-red/10"
            >
                <p className="text-lg md:text-xl font-playfair font-bold text-primary-red mb-2">
                    💝 Each card holds a piece of my heart 💝
                </p>
                <p className="text-sm text-gray-500 uppercase tracking-widest font-bold">
                    All 50 reasons why you mean everything to me
                </p>
            </motion.div>
        </div>
    );
};

export default LoveList;
